import React from "react";
import ReportCard from "../../components/ui/ReportCard";
import { ArrowUpIcon } from "@chakra-ui/icons";

export default function ApprovedReports() {
  return (
    <ReportCard text={120} title="Approved Reports" icon={<ArrowUpIcon />} />
  );
}
